export enum ExportType {
    All = 0,
    Beneficiries = 1,
    Dependents = 2
}
export enum CardState {
    Active = 0,
    Blocked = 1,
    Canceled = 2
}

export type FilterBeneficiarySearchParameterByExportDTO = {
    StartDate: string,
    EndDate: string,
    ExportType: ExportType,
    CardState: CardState[]
}